// @ts-nocheck
import { useState, useEffect } from 'react'
import { MessageCircle } from 'lucide-react'
import ChatPanel from './ChatPanel'
import { useChat } from '../hooks/useChat'

export default function ChatToggleButton() {
  const [isOpen, setIsOpen] = useState(false)
  const [hasUnread, setHasUnread] = useState(false)
  const { messages } = useChat()
  const lastMessageCountRef = useState(0)

  // 新しいメッセージが来たら未読バッジを表示
  useEffect(() => {
    if (!isOpen && messages.length > lastMessageCountRef.current) {
      setHasUnread(true)
    }
    lastMessageCountRef.current = messages.length
  }, [messages, isOpen])

  const handleToggle = () => {
    setIsOpen(!isOpen)
    if (!isOpen) {
      setHasUnread(false) // チャットを開いたら未読をクリア
    }
  }

  return (
    <>
      {!isOpen && (
        <button
          onClick={handleToggle}
          className="fixed bottom-4 right-4 w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all z-40 hover:scale-110 active:scale-95"
          title="チャットを開く"
        >
          <MessageCircle className="w-6 h-6" />
          {hasUnread && (
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full border-2 border-white flex items-center justify-center">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
            </span>
          )}
        </button>
      )}
      
      <ChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}
